export default __webpack_public_path__ + "static/media/session_expired.81c97916.svg";